import { AlpacaMark } from "@/components/AlpacaMark.tsx";
import { cn } from "@/lib/utils.ts";

/** Isotipo de Alpaca POS. */
export function BrandMark({ className }: { className?: string }) {
  return <AlpacaMark className={cn("h-10 w-10 shrink-0", className)} />;
}

/** Isotipo + nombre, con una línea opcional debajo. */
export function BrandLockup({ caption }: { caption?: string }) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <BrandMark />
      <div className="min-w-0">
        <p className="truncate text-base font-extrabold leading-tight text-slate-900">
          Alpaca <span className="text-brand-600">POS</span>
        </p>
        {caption && <p className="truncate text-xs font-medium text-slate-500">{caption}</p>}
      </div>
    </div>
  );
}
